import Swiper, { Navigation } from 'swiper';
export default () => {
	(function ($) {
		if ($('.section--applications').length) {
			// init Swiper:
			const swiper = new Swiper('.section__content--swiper', {
				modules: [Navigation],
				autoHeight: true,
				spaceBetween: 40,
				slidesPerView: 'auto',
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
			});
		}
	})(jQuery);
}
